module.exports = __webpack_public_path__ + "img/mini-cuper.5360a427.png";